// Save last search queries
document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname.includes('/search')) {
    const params = new URLSearchParams(window.location.search);
    const searchQuery = params.get('q');

    if (searchQuery && searchQuery.trim() !== '') {
      try {
        const lastSearch = localStorage.getItem('last_search_keyword');
        if (lastSearch) {
          const currentData = JSON.parse(lastSearch);

          // search query is already in the list
          if (currentData.includes(searchQuery.trim())) {
            return;
          }

          currentData.unshift(searchQuery.trim());

          // remove last array if more than 10
          if (currentData.length > 10) {
            currentData.pop();
          }

          localStorage.setItem('last_search_keyword', JSON.stringify(currentData));
          return;
        } else {
          localStorage.setItem('last_search_keyword', JSON.stringify([searchQuery.trim()]));
        }
      } catch (e) {
        console.warn('LocalStorage is not available:', e);
      }
    }
  }
})